import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import Newsletter from "./pages/Newsletter";
import SundayEditKit from "./pages/SundayEditKit";
import Editing from "./pages/Editing";
import EditingOffer from "./pages/EditingOffer";
import MetaAdsStrategy from "./pages/MetaAdsStrategy";
import SocialMediaService from "./pages/SocialMediaService";
import UGCService from "./pages/UGCService";
import { Toaster } from "./components/ui/sonner";
import InteractiveGrid from "./components/ui/InteractiveGrid";

function App() {
  return (
    <div className="App">
      <InteractiveGrid />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/sunday-edit-kit" element={<SundayEditKit />} />
          <Route path="/editing" element={<Editing />} />
          <Route path="/editing-offer" element={<EditingOffer />} />
          <Route path="/meta-ads-strategy" element={<MetaAdsStrategy />} />
          <Route path="/social-media-service" element={<SocialMediaService />} />
          <Route path="/ugc-production" element={<UGCService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
